export const TTS_TEXT_AREA_PADDING = 12
export const TTS_TEXT_AREA_INITIAL_HEIGHT = 44
export const TTS_TEXT_AREA_ACTIVE_MIN_HEIGHT = 84
export const TTS_TEXT_AREA_MAX_HEIGHT = 300
export const TTS_TEXT_AREA_MAX_CHARACTERS = 900
export const TTS_INSTRUCTION_TEXT_AREA_HEIGHT = 112

export const TTS_ITEM_SPEAKER_HEIGHT = 26
export const TTS_ITEM_GAP = 10

export const TTS_ACTION_BUTTONS_HEIGHT = 20
export const TTS_ACTION_BUTTONS_GAP = 8
export const TTS_ACTIVE_ITEM_BACKGROUND_PADDING = 2

export const TTS_SPEAKER_ITEM_CLASS_NAME = 'tts-speaker-item'
export const TTS_LANGUAGE_ITEM_CLASS_NAME = 'tts-language-item'
